import React from "react";
import axios from "axios"
import { DASHBOARD_URL, BASIC_TOKEN_HEADER, BROADCAST_MSG_FETCH } from "../constants/api.config"
import { useHistory, useLocation } from 'react-router-dom';
import { notify } from "./notifyFunction";




export const getUserToken = () => {

  let sessionIdString = sessionStorage.getItem("RNB_SESSION_ID")
  let loginData = JSON.parse(localStorage.getItem("RNB_LOGGED_IN_USER_DATA")) || {}

  if (sessionIdString != null && Object.keys(loginData)?.length) {
    // return true
    return `${sessionIdString};;;${loginData?.UniqueUID}`

  }
  // return cookies.get('jwt_token')
  globalLogoutFunction()
  return false
}



export async function killSession() {

  let sessionIdString = sessionStorage.getItem("RNB_SESSION_ID")
  let loginData = JSON.parse(localStorage.getItem("RNB_LOGGED_IN_USER_DATA")) || {}


  if (sessionIdString != null && Object.keys(loginData)?.length) {
    let token = `${sessionIdString};;;${loginData?.UniqueUID}`
    try {
      const params = new URLSearchParams({
        UserCode: token,
        // DivCode: "RNB",
        // ParentCode: "",
        // ModuleCode: moduleCode,
        // prmLangCode: "en-US",
      });
      const config = {
        method: 'GET',
        url: `${DASHBOARD_URL}/CloseUserSession?${params.toString()}`,
        headers: BASIC_TOKEN_HEADER
      };

      const response = await axios(config);

      if (response.data.ErrMsg[0].ErrCode === "1") {
        console.log("session closed successfully")
        return true
      }
      else {
        console.log("session closed failed")
        return false
      }

    } catch (error) {
      console.error("Error in globalLogoutFunction:", error);
    }
  }
  return
}

export const globalLogoutFunction = async () => {
  // const history = useHistory()

  const isSessionClosed = await killSession()
  if (isSessionClosed) {

    console.log("session closed successfully")

  }
  else {
    console.log("session closed failed")
  }

  localStorage.clear()
  sessionStorage.clear()
  // history.push("/login")

}

export const broadCastMessageHandler = async () => {

  // const history = useHistory()
  const params = new URLSearchParams({
    LoginID: getUserToken(),
  });
  const config = {
    method: "GET",
    url: `${DASHBOARD_URL}/${BROADCAST_MSG_FETCH}?${params.toString()}`,
    headers: BASIC_TOKEN_HEADER
  };

  try {
    const result = await axios(config);
    if (result?.data?.Links) {

      // notify(result.data.Links[0].Message, "success");
      return result.data.Links
      // setCurrentMessage(result.data.Links);

    }
    else if (result?.data?.ErrMsg[0]?.ErrCode === "-1") {

      notify(result?.data?.ErrMsg[0]?.ErrMsg, "error");

      await globalLogoutFunction()

      return "LOGOUT"
    }



  } catch (error) {
    console.error('Error fetching broadcast messages:', error);
    return
  }


}


// Sets a session cookie (no expires/max-age) that is cleared when the browser is closed
// export const setSessionCookie = (name, value) => {
//   if (typeof document === 'undefined') return;
//   const encodedName = encodeURIComponent(name);
//   const encodedValue = encodeURIComponent(value);
//   document.cookie = `${encodedName}=${encodedValue}; path=/; SameSite=Lax`;
// }

// export const getCookie = (name) => {
//   if (typeof document === 'undefined') return null;
//   const encodedName = encodeURIComponent(name) + '=';
//   const cookies = document.cookie ? document.cookie.split('; ') : [];
//   for (let i = 0; i < cookies.length; i++) {
//     const cookie = cookies[i];
//     if (cookie.indexOf(encodedName) === 0) {
//       return decodeURIComponent(cookie.substring(encodedName.length));
//     }
//   }
//   return null;
// }

// export const clearCookie = (name) => {
//   if (typeof document === 'undefined') return;
//   document.cookie = `${encodeURIComponent(name)}=; Max-Age=0; path=/; SameSite=Lax`;
// }
